<script lang="ts">
  import type { IntegrationPlatformRowConfig } from "../../helpers/types";

  export let platform: IntegrationPlatformRowConfig;
  export let active: boolean;
  export let onClick = (platform: IntegrationPlatformRowConfig) => {};
</script>

<div class="integration-row">
  <div class="icon-container">
    <img
      class="logo_img"
      alt={`${platform.name} logo`}
      src={`static/assets/logo/logo_${platform.name.toLowerCase()}.png`}
    />
  </div>
  <button
    class="connect-btn {active && 'btn-active'}"
    disabled={platform.disabled}
    on:click={() => onClick(platform)}>{platform.active ? "manage" : "connect"}</button
  >
</div>

<style>
  button {
    height: 50px;
    width: 200px;
    border-radius: 58px;
    background-color: var(--rekki-neutral-01);
    border: 0 none;
    white-space: nowrap;
    font-family: "REKKI-OCD";
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.2px;
    margin: 0 auto;
    text-transform: uppercase;
  }

  .btn-active {
    background-color: var(--rekki-neutral-04);
    color: var(--rekki-light);
  }

  .icon-container {
    display: flex;
    flex: 1;
    align-items: center;
  }

  .integration-row {
    display: flex;
    align-content: center;
    border-radius: 8px;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-right: 8px;
    border: 1px solid;
    border-color: var(--rekki-neutral-01);
    width: 225px;
    height: 188px;
    padding: 0 8px;
    flex-direction: column;
  }

  .logo_img {
    margin: 0 auto;
    height: auto;
    max-width: 50%;
    max-height: 50%;
  }

  .connect-btn {
    align-self: flex-end;
    margin-bottom: 10px;
  }
  button:active {
    filter: brightness(1.1);
  }
</style>
